import { useRouter } from "../../../../../lib/routerContext";
import { FilterParams, UrlFilters } from "./types";
import { parseFilterParams } from "./urlParser";

export const useFilterParser = (): UrlFilters => {
  const router = useRouter<FilterParams>();
  const params = (router && router.query) || { filter: "" };
  return parseFilterParams(params);
};
